.antSpin:global(.ant-spin-spinning) {
  :global(.ant-spin-container) {
    opacity: 0.2;
  }
}
